import React from 'react';
import { Cta1, SubpageBanner } from '../components';
import { useTranslation } from 'react-i18next';

const BlockchainNedir = () => {
    const { t } = useTranslation();

    return (
        <div className="subpage-content">
            {/* Page Banner */}
            <SubpageBanner 
                title={t('blockchainNedir.bannerTitle')}
                path="/nordex-academy"
            />

            <div className="academy-page">
                {/* Giriş */}
                <div className="academy-intro-section py-5">
                    <div className="container">
                        <p className="academy-intro-text">{t('blockchainNedir.intro.p1')}</p>
                        <p className="academy-intro-text fw-bold">{t('blockchainNedir.intro.p2')}</p>
                        <ul className="academy-list">
                            {t('blockchainNedir.intro.items', { returnObjects: true }).map((item, index) => (
                                <li key={index}>{item}</li>
                            ))}
                        </ul>
                    </div>
                </div>

                {/* Bölüm 1: Blockchain Basitçe Nedir? */}
                <div className="academy-section">
                    <div className="container">
                        <h2 className="academy-section-title">{t('blockchainNedir.section1.title')}</h2>
                        <p className="academy-section-text">{t('blockchainNedir.section1.p1')}</p>
                        <p className="academy-section-text">{t('blockchainNedir.section1.p2')}</p>
                        
                        {/* Tablo */}
                        <div className="academy-table-wrapper">
                            <table className="academy-table">
                                <thead>
                                    <tr>
                                        <th>{t('blockchainNedir.section1.table.header1')}</th>
                                        <th>{t('blockchainNedir.section1.table.header2')}</th>
                                        <th>{t('blockchainNedir.section1.table.header3')}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {t('blockchainNedir.section1.table.rows', { returnObjects: true }).map((row, index) => (
                                        <tr key={index}>
                                            <td>{row.feature}</td>
                                            <td>{row.traditional}</td>
                                            <td>{row.blockchain}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>

                        <div className="academy-highlight-box mt-4">
                            <h4>{t('blockchainNedir.section1.analogy.title')}</h4>
                            <p>{t('blockchainNedir.section1.analogy.text')}</p>
                        </div>
                    </div>
                </div>

                {/* Bölüm 2: Blockchain Nasıl Çalışır? */}
                <div className="academy-section">
                    <div className="container">
                        <h2 className="academy-section-title">{t('blockchainNedir.section2.title')}</h2>
                        <p className="academy-section-text">{t('blockchainNedir.section2.intro')}</p>

                        {/* Adımlar */}
                        {t('blockchainNedir.section2.steps', { returnObjects: true }).map((step, index) => (
                            <div key={index} className="academy-step-card mb-4">
                                <h3 className="academy-step-title">{step.title}</h3>
                                <p className="academy-step-text">{step.desc}</p>
                                {step.details && (
                                    <ul className="academy-list">
                                        {step.details.map((detail, idx) => (
                                            <li key={idx}>{detail}</li>
                                        ))}
                                    </ul>
                                )}
                                {step.example && (
                                    <div className="academy-example-box">
                                        <p>{step.example}</p>
                                    </div>
                                )}
                            </div>
                        ))}

                        <div className="academy-highlight-box mt-4">
                            <h4>{t('blockchainNedir.section2.duration.title')}</h4>
                            <ul className="academy-list">
                                {t('blockchainNedir.section2.duration.items', { returnObjects: true }).map((item, index) => (
                                    <li key={index}>{item}</li>
                                ))}
                            </ul>
                            <p className="mt-2"><strong>{t('blockchainNedir.section2.duration.comparison')}</strong></p>
                        </div>
                    </div>
                </div>

                {/* Bölüm 3: Blok Nedir? */}
                <div className="academy-section">
                    <div className="container">
                        <h2 className="academy-section-title">{t('blockchainNedir.section3.title')}</h2>
                        <p className="academy-section-text">{t('blockchainNedir.section3.intro')}</p>

                        {/* Blok Bileşenleri Tablosu */}
                        <div className="academy-table-wrapper">
                            <table className="academy-table">
                                <thead>
                                    <tr>
                                        <th>{t('blockchainNedir.section3.table.header1')}</th>
                                        <th>{t('blockchainNedir.section3.table.header2')}</th>
                                        <th>{t('blockchainNedir.section3.table.header3')}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {t('blockchainNedir.section3.table.rows', { returnObjects: true }).map((row, index) => (
                                        <tr key={index}>
                                            <td><strong>{row.component}</strong></td>
                                            <td>{row.description}</td>
                                            <td><code>{row.example}</code></td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>

                        <div className="academy-highlight-box mt-4">
                            <h4>{t('blockchainNedir.section3.hash.title')}</h4>
                            <p>{t('blockchainNedir.section3.hash.desc')}</p>
                            <div className="academy-example-box mt-3">
                                <p><strong>{t('blockchainNedir.section3.hash.example.title')}</strong></p>
                                <ul className="academy-list">
                                    {t('blockchainNedir.section3.hash.example.items', { returnObjects: true }).map((item, index) => (
                                        <li key={index}>{item}</li>
                                    ))}
                                </ul>
                                <p className="mt-2">{t('blockchainNedir.section3.hash.example.conclusion')}</p>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Bölüm 4: Blockchain Türleri */}
                <div className="academy-section">
                    <div className="container">
                        <h2 className="academy-section-title">{t('blockchainNedir.section4.title')}</h2>
                        
                        {t('blockchainNedir.section4.types', { returnObjects: true }).map((type, index) => (
                            <div key={index} className="academy-type-card mb-4">
                                <h3 className="academy-type-title">{type.title}</h3>
                                <p className="academy-type-desc">{type.desc}</p>
                                <div className="academy-type-features">
                                    <h5>{t('blockchainNedir.section4.featuresLabel')}</h5>
                                    <ul className="academy-list">
                                        {type.features.map((feature, idx) => (
                                            <li key={idx}>{feature}</li>
                                        ))}
                                    </ul>
                                </div>
                                <p className="academy-type-examples">
                                    <strong>{t('blockchainNedir.section4.examplesLabel')}</strong> {type.examples}
                                </p>
                            </div>
                        ))}
                    </div>
                </div>

                {/* Bölüm 5: Avantajlar */}
                <div className="academy-section">
                    <div className="container">
                        <h2 className="academy-section-title">{t('blockchainNedir.section5.title')}</h2>
                        
                        {t('blockchainNedir.section5.advantages', { returnObjects: true }).map((advantage, index) => (
                            <div key={index} className="academy-advantage-card mb-4">
                                <h3 className="academy-advantage-title">{advantage.title}</h3>
                                <p className="academy-advantage-desc">{advantage.desc}</p>
                                {advantage.howProvided && (
                                    <>
                                        <h5>{advantage.howProvided.label}</h5>
                                        <ul className="academy-list">
                                            {advantage.howProvided.items.map((item, idx) => (
                                                <li key={idx}>{item}</li>
                                            ))}
                                        </ul>
                                    </>
                                )}
                                {advantage.benefits && (
                                    <>
                                        <h5>{advantage.benefits.label}</h5>
                                        <ul className="academy-list">
                                            {advantage.benefits.items.map((item, idx) => (
                                                <li key={idx}>{item}</li>
                                            ))}
                                        </ul>
                                    </>
                                )}
                                {advantage.comparison && (
                                    <div className="academy-example-box mt-3">
                                        <p><strong>{advantage.comparison.label}</strong></p>
                                        <ul className="academy-list">
                                            {advantage.comparison.items.map((item, idx) => (
                                                <li key={idx}>{item}</li>
                                            ))}
                                        </ul>
                                    </div>
                                )}
                            </div>
                        ))}
                    </div>
                </div>

                {/* Bölüm 6: Günlük Hayatta Kullanım */}
                <div className="academy-section">
                    <div className="container">
                        <h2 className="academy-section-title">{t('blockchainNedir.section6.title')}</h2>
                        <p className="academy-section-text">{t('blockchainNedir.section6.intro')}</p>
                        
                        <div className="row g-3 mt-4">
                            {t('blockchainNedir.section6.useCases', { returnObjects: true }).map((useCase, index) => (
                                <div key={index} className="col-md-6">
                                    <div className="academy-usecase-card">
                                        <h4 className="academy-usecase-title">{useCase.title}</h4>
                                        <p className="academy-usecase-desc">{useCase.desc}</p>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>

                {/* Özet */}
                <div className="academy-section academy-summary-section">
                    <div className="container">
                        <h2 className="academy-section-title">{t('blockchainNedir.summary.title')}</h2>
                        <p className="academy-section-text">{t('blockchainNedir.summary.text')}</p>
                        <p className="academy-section-text mt-3">{t('blockchainNedir.summary.nordex')}</p>
                    </div>
                </div>

                <Cta1
                    title={<><span style={{color: '#31cce5' }}>{t('home.ctaInvestment')}</span> {t('home.ctaTitle')}</>}
                subtitle={<span>{t('home.ctaSubtitle')}</span>}
                />
            </div>
        </div>
    );
};

export default BlockchainNedir;
